import React, { FC } from "react";
import { MailSuccess } from "../common/shape/MailSuccess";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { ColorPalette } from "@/constants";
import { ButtonPrimary } from "../common/buttons/ButtonPrimary";

interface Popup {
    onGoToHome: () => void
}

const Popup: FC<Popup> = ({ onGoToHome }) => {
    return (
        <div className="fixed inset-0 z-100 flex items-center justify-center bg-opacity-10 bg-secondary-100 backdrop-filter backdrop-blur-md">
            <div className="flex flex-col relative w-10/12 sm:w-9/12 bg-white rounded">
                <div className="flex flex-col p-6 sm:p-14 border items-center justify-center ">
                    <MailSuccess />
                    <h3 className="text-xl sm:text-2xl text-accent-100 font-body font-bold mt-4 sm:mt-8 mb-2">Terima Kasih!</h3>
                    <div className="mb-4 sm:mb-6">
                        <FontAwesomeIcon icon={faCircleCheck} size="xl" style={{ color: ColorPalette.primaryGreen100 }} />
                        <span className="text-base sm:text-lg text-secondary-100 font-body font-bold ml-3">Pendaftaran Kamu Berhasil</span>
                    </div>
                    <div>
                        {/* Because this section different from the new  UI */}

                       {/* <p className="text-center tex-sm font-body font-normal">Informasi lebih lanjut akan segera kami hubungi kamu melalui WhatsApp. Mohon pastikan nomor WhatsApp kamu aktif.</p>
                        <br />
                        <p className="text-center tex-sm font-body font-normal">Jika dalam waktu 1x24 jam kami belum menghubungi Anda, mohon hubungi layanan
                            pelanggan kami di nomor berikut: 0831-3123-3333</p> */}
                            
                        <p className="text-center tex-sm font-body font-normal">Terima kasih atas pengiriman pendaftarannya, tunggu panitia menghubungi kamu ya! Panitia akan </p>
                        <br />
                        <p className="text-center tex-sm font-body font-normal">menghubungi kamu, maksimal h+2 dari pendaftaran</p>
                    </div>
                    <div className="w-full h-7 sm:h-10" />
                    <ButtonPrimary title="Kembali Ke Beranda" onClick={onGoToHome} />
                </div>
            </div>
        </div>
    );
};

export default Popup;